export class storeIpAddressesDTO{
    globalIpAddress : string;
    loadBalancerIpAddress : string;
    servicesGatewayIpAddress : string;
}
